import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { RestDataService,StatusBarService, StatusMessage,UnitsService } from 'pumpcalc-core';
import { environment } from '../../environments/environment';

@Component({
  selector: 'pump-set-detail',
  templateUrl: './pump-set-detail.component.html',
  styleUrls: ['./pump-set-detail.component.css']
})
export class PumpSetDetailComponent implements OnChanges {

  @Input() pumpSetDetailId: string;
  @Input() isUserPumpSet:boolean;
  @Input() public pumpSetDetail;
  @Output() loaded:EventEmitter<any>=new EventEmitter();
  status: StatusMessage;

  constructor(public unitsService: UnitsService,    
    private statusBarService: StatusBarService,
    private restDataService :RestDataService ) {
    this.status = this.statusBarService.clear();    
  }

  section(code: number) {
    switch (code) {
      case 0: return "Circular";
      case 1: return "Annular";
      case 2: return "Rectangular";
    }
  }

  ngOnChanges() {
    this.status = this.statusBarService.clear();
    if(!this.pumpSetDetailId){return;}    
    this.status = this.statusBarService.statusLoading("Loading Pumpset details");
    this.restDataService.get(this.restDataService.addIdToURL(this.pumpSetDetailId,(this.isUserPumpSet?environment.customPumpSetDetailsURL:environment.pumpSetDetailsURL))).subscribe((pumpsetDetail:any)=>{
      this.pumpSetDetail=pumpsetDetail;
      this.status = this.statusBarService.clear();
      this.loaded.emit(this.pumpSetDetail);
    })
  }

}
